/**
 * キニッタ！内で共通に使う変数（画面間で使用する変数）を定義する
 * 【注意】画面内（同一名のvueとts）で使用する変数は各ts内に定義すること
 */

// Vue
import { reactive, ref } from 'vue';

import * as GVar from '@/components/00/Var00';      // 共通変数
import * as GFunc from '@/components/00/Common00';  // 共通メソッド

//-----------------------------------------------------------------
// 変数定義
//-----------------------------------------------------------------

// 店舗検索結果一覧
export let c050010Keep: any = null; // c050010のパラメータを保存
export function setC050010Keep(val: any) { c050010Keep = val; }

export let c050010KeepIdx = -1; // c050010のResultsの選択されているインデックスを保存
export function setC050010KeepIdx(val: number) { c050010KeepIdx = val; }

// 店舗感染対策状況
export let c050030Keep: any = null; // c050030のパラメータを保存
export function setC050030Keep(val: any) { c050030Keep = val; }

// 店舗感染対策状況サマリー
export let c050040Keep: any = null; // c050040のパラメータを保存
export function setC050040Keep(val: any) { c050040Keep = val; }

export let c050040KeepIdx = -1; // c050040のResult内Mpt154の選択されているインデックスを保存
export function setC050040KeepIdx(val: number) { c050040KeepIdx = val; }

// 店舗一覧
export let c050070Keep: any = null; // c050070のパラメータを保存
export function setC050070Keep(val: any) { c050070Keep = val; }

export let c050070KeepIdx = -1; // c050070のresults内Mpt151の選択されているインデックスを保存
export function setC050070KeepIdx(val: number) { c050070KeepIdx = val; }

// 店舗グループ一覧
export let c050100Keep: any = null; // c050100のパラメータを保存
export function setC050100Keep(val: any) { c050100Keep = val; }

export let c050100KeepIdx = -1; // c050100のresults内Mpt151の選択されているインデックスを保存
export function setC050100KeepIdx(val: number) { c050100KeepIdx = val; }

// 会員ランク情報一覧
export let c050110Keep: any = null; // c050110のパラメータを保存
export function setC050110Keep(val: any) { c050110Keep = val; }

export let c050110KeepIdx = -1; // c050100のresults内Mpt160の選択されているインデックスを保存
export function setC050110KeepIdx(val: number) { c050110KeepIdx = val; }

// チャット用クラス

// チャットの内容
export class ChatContent
{
  id = "";        // 自動採番されたドキュメントID
  msg = "";       // メッセージ
  uid = 0;        // 書き込みユーザーID
  shpid = 0;      // 店舗ID
  who = "";       // 書き込み者 "S":店舗、"C":顧客
  created = Date(); // 書き込み日時
  readFlag = "0"; // 既読フラグ "0":未読、"1":既読
  deleted = null; // 削除日時
  constructor(id: string, doc: any)
  {
      this.id = id;      
      this.msg = String(doc.msg);
      this.uid = doc.uid;
      this.shpid = doc.shpid;
      this.who = doc.who;
      this.created = doc.created;
      this.readFlag = doc.readFlag;
      this.deleted = doc.deleted;
  }
}

//-----------------------------------------------------------------
// 変数定義（画面間受け渡し変数）
//-----------------------------------------------------------------

// 会員情報ページからポイント登録確認ページへのパラメーター受け渡し用
export let s05002007_inputData: any = null;
export function setS05002007_inputData(val: any) { s05002007_inputData = val; }

//-----------------------------------------------------------------
// 変数定義
//-----------------------------------------------------------------

export let sCurShpId = 0;    // 選択中の自店舗ID(ショップモード時)
export function setSCurShpId(val: number) { sCurShpId = val; }

// export let s05002001_loaded = false;  // 店舗一覧の２重ロード防止用 true - ロード済み、 false - 未ロード
// export function setS05002001_loaded(val: boolean) { s05002001_loaded = val; }

export let sCurShpGrpId = 0;    // 選択中の自店舗グループID(ショップモード時)
export function setSCurShpGrpId(val: number) { sCurShpGrpId = val; }

export let shpGrp_loaded = false;  // 店舗グループ一覧の２重ロード防止用 true - ロード済み、 false - 未ロード
export function setShpGrp_loaded(val: boolean) { shpGrp_loaded = val; }

//-----------------------------------------------------------------
// 関数定義
//-----------------------------------------------------------------
/**
 * アプリ固有グローバル変数の再初期化
 * ユーザーが変わった時に呼ばれる
 */
export function reInitLocalVars()
{
    if ( GFunc.isDebugEnabled() ) {console.debug("reInitLocalVars()");}
    // 共通変数の初期化
    GVar.reInitVars();
    c050010Keep = null;  // c050010のパラメータを保存
    c050010KeepIdx = -1; // c050010のResultsの選択されているインデックスを保存
    c050030Keep = null;  // c050030のパラメータを保存
    c050040Keep = null;  // c050040のパラメータを保存
    c050040KeepIdx = -1; // c050040のResult内Mpt154の選択されているインデックスを保存
    sCurShpGrpId = 0;    // 選択中の店舗グループID
    sCurShpId = 0;       // 選択中の店舗ID
}